import type { UpdateEmailTemplateDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import { useInvalidateAllShopEmailTemplates } from "./use-get-all-shop-email-templates";

export default function useUpdateEmailTemplate(shopId: string) {
  const invalidate = useInvalidateAllShopEmailTemplates(shopId);

  return useApiMutation(
    "patch",
    "/shops/{shopId}/email-templates/{templateId}",
    {
      invalidate,
      mapVariables: ({
        templateId,
        requestBody,
      }: {
        templateId: string;
        requestBody: UpdateEmailTemplateDto;
      }) => ({
        params: { path: { shopId, templateId } },
        body: requestBody,
      }),
    },
  );
}
